// GLOBAL VARIABLE SETUP
// =================================================================================================
// COMPONENTS
import React from 'react';
import '../styles/modal.css'


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class Editor extends React.Component {


	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {};

		window.trackEvent( 'Pageview', {
			action: 'global-modal',
			modalTitle: this.state.title,
			modalMessage: this.state.msg
		});
	}


	// =============================================================================================
	componentDidMount() {

		this.setState( prevState => ( this.props.error ) )
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {
		let title = this.state.title,
			message = this.state.msg,
			btnText = ( this.state.btn && this.state.btn.text ) || 'Ok';

		return <div className="modal__shade" onClick={ ( e ) => this.props.modalHandler( e ) }>

			<div className="modal__shade__container">

				<h3>{ title }</h3>
				<p>{ message }</p>

				<div className="btn-group">
					<button className="btn btn_blue" onClick={ ( e ) => this.props.modalHandler( e ) }>{ btnText }</button>
				</div>
			</div>
		</div>
	}
}

export default Editor;


// WEBPACK FOOTER //
// ./src/components/modal.js